export default __webpack_public_path__ + "static/media/ensvee-logo-white-text.57878bd9.svg";